/**
 * Due to some restrictions from the IPS team we need to only send 7 bit characters, to that end we need to add some support for HTML entities.
 * Due to the HTML sanitization, unicode makes for the easiest way to convert entities a run-time.
 */

// Selected list is inspired by https://www.w3.org/wiki/Common_HTML_entities_used_for_typography
export const supportedEntities: Record<string, string> = {
  // Punctuation symbols
  "&amp;": "\u0026",
  "&lsquo;": "\u2018",
  "&rsquo;": "\u2019",
  "&sbquo;": "\u201A",
  "&ldquo;": "\u201C",
  "&rdquo;": "\u201D",
  "&bdquo;": "\u201E",
  "&laquo;": "\u00AB",
  "&raquo;": "\u00BB",
  "&ndash;": "\u2013",
  "&mdash;": "\u2014",
  // Math symbols
  "&asymp;": "\u2248",
  "&frac12;": "\u00BD",
  "&ge;": "\u2265",
  "&le;": "\u2264",
  "&ne;": "\u2260",
  // Misc symbols
  "&bull;": "\u2022",
  "&copy;": "\u00A9",
  "&dagger;": "\u2020",
  "&Dagger;": "\u2021",
  "&deg;": "\u00B0",
  "&hellip;": "\u2026",
  "&nbsp;": "\u00A0",
  "&middot;": "\u00B7",
  "&plusmn;": "\u00B1",
  "&para;": "\u00B6",
  "&prime;": "\u2032",
  "&Prime;": "\u2033",
  "&reg;": "\u00AE",
  "&sect;": "\u00A7",
  "&trade;": "\u2122",
  // Currency
  "&cent;": "\u00A2",
  "&euro;": "\u20A0",
  "&pound;": "\u00A3",
  "&yen;": "\u00A5",
};
